import { Dir, Dirs } from "../../common";
import { PhysicTile } from "../tile/tiles";
export class Entity {
    constructor(level) {
        this.x = 0;
        this.y = 0;
        this.w = 0;
        this.h = 0;
        this.dx = 0;
        this.dy = 0;
        this.animCount = 0;
        this.canCollide = true;
        this.done = false;
        this.debugColor = '#ff00ff';
        this.level = level;
    }
    update(dt) {
        this.animCount += dt;
        this.move(dt);
    }
    move(dt) {
        this.moveX(dt);
        this.moveY(dt);
    }
    moveX(dt) {
        this.x += this.dx * dt;
        this.x = Math.round(this.x);
        if (!this.canCollide) {
            return;
        }
        if (this.dx < 0) {
            if (this.isTouchingTile(this.level.tiles, PhysicTile.Wall, { dir: Dir.Left })) {
                this.onLeftCollision();
            }
        }
        else if (this.dx > 0) {
            if (this.isTouchingTile(this.level.tiles, PhysicTile.Wall, { dir: Dir.Right })) {
                this.onRightCollision();
            }
        }
    }
    moveY(dt) {
        this.y += this.dy * dt;
        this.y = Math.round(this.y);
        if (!this.canCollide) {
            return;
        }
        if (this.dy < 0) {
            if (this.isTouchingTile(this.level.tiles, PhysicTile.Wall, { dir: Dir.Up })) {
                this.onUpCollision();
            }
        }
        else if (this.dy > 0) {
            if (this.isTouchingTile(this.level.tiles, PhysicTile.Wall, { dir: Dir.Down })) {
                this.onDownCollision();
            }
        }
    }
    onLeftCollision() {
        const resetPos = this.level.tiles.getTileCoordFromCoord({ x: this.minX, y: 0 }, { x: 1, y: 0 });
        this.minX = resetPos.x + 1;
        this.dx = 0;
    }
    onRightCollision() {
        const resetPos = this.level.tiles.getTileCoordFromCoord({ x: this.maxX, y: 0 }, { x: 0, y: 0 });
        this.maxX = resetPos.x - 1;
        this.dx = 0;
    }
    onUpCollision() {
        const resetPos = this.level.tiles.getTileCoordFromCoord({ x: 0, y: this.minY }, { x: 0, y: 1 });
        this.minY = resetPos.y + 1;
        this.dy = 0;
    }
    onDownCollision() {
        const resetPos = this.level.tiles.getTileCoordFromCoord({ x: 0, y: this.maxY }, { x: 0, y: 0 });
        this.maxY = resetPos.y - 1;
        this.dy = 0;
    }
    isTouchingTile(tileSource, tile, { dir = undefined, offset = undefined } = {}) {
        if (!Array.isArray(tile)) {
            tile = [tile];
        }
        const corners = Dirs.cornersInDirection(dir);
        for (const corner of corners) {
            const x = this.x + corner.x * this.w + (offset?.x ?? 0);
            const y = this.y + corner.y * this.h + (offset?.y ?? 0);
            for (const t of tile) {
                if (tileSource.getTileAtCoord({ x, y }) === t) {
                    return true;
                }
            }
        }
        return false;
    }
    isOnTile(tileSource, tile, { dir = undefined, offset = undefined } = {}) {
        if (!Array.isArray(tile)) {
            tile = [tile];
        }
        const corners = Dirs.cornersInDirection(dir);
        for (const corner of corners) {
            const x = this.x + corner.x * this.w + (offset?.x ?? 0);
            const y = this.y + corner.y * this.h + (offset?.y ?? 0);
            for (const t of tile) {
                if (tileSource.getTileAtCoord({ x, y }) !== t) {
                    return false;
                }
            }
        }
        return true;
    }
    isTouchingEntity(other) {
        return this.maxX > other.minX && this.minX < other.maxX && this.maxY > other.minY && this.minY < other.maxY;
    }
    render(context) {
        if (this.debugColor) {
            context.fillStyle = this.debugColor;
            context.fillRect(this.x, this.y, this.w, this.h);
            // console.log(`Rendering entity at ${this.x}, ${this.y} with size ${this.w}, ${this.h}`);
        }
    }
    //#region Getters and setter for min / mid / max.
    get minX() {
        return this.x;
    }
    get minY() {
        return this.y;
    }
    get maxX() {
        return this.x + this.w;
    }
    get maxY() {
        return this.y + this.h;
    }
    get midX() {
        return this.x + this.w / 2;
    }
    get midY() {
        return this.y + this.h / 2;
    }
    set minX(val) {
        this.x = val;
    }
    set minY(val) {
        this.y = val;
    }
    set maxX(val) {
        this.x = val - this.w;
    }
    set maxY(val) {
        this.y = val - this.h;
    }
    set midX(val) {
        this.x = val - this.w / 2;
    }
    set midY(val) {
        this.y = val - this.h / 2;
    }
}
